export const BUILDER_HEADER = 'builder-header';
export const HEADER_CTA = 'header-cta';
export const HEADER_RESUME_TEMPLATES_BUTTON = 'header-resume-templates-buttons';
export const HERO_CTA = 'hero-cta';
export const BACKDROP = 'backdrop';
